import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';

import { Label } from 'core/components/label';
import { Button } from 'core/components/button';

const ExportButton = ({ loading, classes, icon, onClick, exportText, loadingText }) => {
  return (
    <Button className={classes.downloadButton} onClick={onClick} type="action" disabled={loading}>
      <div className={classes.iconContainer}>
        {loading ? (
          <CircularProgress size={24} className={classes.downloadLoader} style={{ margin: 0 }} />
        ) : (
          <img src={icon} alt="export" width={32} height={32} />
        )}
      </div>
      <Label variant="body3" className={classes.downloadLabel}>
        {loading ? loadingText : exportText}
      </Label>
    </Button>
  );
};

ExportButton.propTypes = {
  loading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  icon: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  exportText: PropTypes.string.isRequired,
  loadingText: PropTypes.string.isRequired
};

export default ExportButton;
